import Icon from '@xo-union/tk-component-icons';
import { Caption } from '@xo-union/tk-ui-typography';
import React from 'react';
import { IconName as StandardIconName } from '@xo-union/dist-iconography';
import { IconName as VendorIconName } from '@xo-union/dist-vendor-iconography';
import styles from './pageItemIcon.scss';

interface Props {
  icon: string;
}

interface IconData {
  name: StandardIconName | VendorIconName; // fallback / unused when customSvg provided
  label: string;
  customSvg?: React.ReactNode;
}

interface Dictionary<T> {
  [Key: string]: T;
}

export const iconData: Dictionary<IconData> = {
  HeadlineItem: {
    name: 'title',
    label: 'Title',
  },
  ParagraphItem: {
    name: 'paragraph',
    label: 'Text Block',
  },
  AccommodationItem: {
    name: 'category-hrb',
    label: 'Hotel',
  },
  EventGroupItem: {
    name: 'date',
    label: 'Event',
  },
  PersonItem: {
    name: 'guest_single',
    label: 'Person',
  },
  PhotoGalleryItem: {
    name: 'category-phb',
    label: 'Photo Gallery',
  },
  PhotoTimelineItem: {
    name: 'photo_timeline',
    label: 'Photo Timeline',
  },
  PhotoItem: {
    name: 'picture',
    label: 'Photo',
  },
  ActivityItem: {
    name: 'street_view',
    label: 'Activity',
  },
  TransportationItem: {
    name: 'category-tra',
    label: 'Transportation',
  },
  GifItem: {
    name: 'gif',
    label: 'Gif',
  },
  EmbedItem: {
    name: 'playlist',
    label: 'Music',
  },
  QuestionItem: {
    name: 'question',
    label: 'Q&A',
  },
  DressCodeItem: {
    name: 'guest_single',
    label: 'Dress Code',
    customSvg: (
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <path
          d="M24.4886 30.2096H18.1705L26.8042 16.1358C26.983 15.846 26.9902 15.4812 26.823 15.1856L25.8858 13.5261L27.3406 12.5283C27.7112 12.2731 27.8496 11.7872 27.665 11.3748L25.3855 6.26639L29.9604 8.38878L24.4886 30.2096ZM3.03114 8.38878L7.61188 6.26351L5.33088 11.3748C5.14633 11.7872 5.28474 12.2731 5.6553 12.5283L7.11012 13.5261L6.17436 15.1856C6.00711 15.4826 6.01432 15.846 6.1931 16.1358L14.8269 30.2096H8.50294L3.03114 8.38878ZM11.525 3.21257L15.2075 5.75886L14.3381 7.05508L10.5763 4.3819L11.525 3.21257ZM8.87926 12.4649L7.361 11.4253L9.2873 7.10842L14.0137 25.3016L8.07759 15.6268L9.16474 13.6991C9.40265 13.2752 9.27865 12.7403 8.87926 12.4649ZM16.4936 7.20791L17.6284 8.90064C17.7697 9.1097 17.9888 9.25389 18.2383 9.30002C18.2945 9.31012 18.3507 9.31589 18.407 9.31589C18.6002 9.31589 18.7905 9.25533 18.9505 9.14142L21.765 7.14015L16.4994 27.4139L11.2352 7.1488L14.0367 9.14142C14.1968 9.25533 14.3871 9.31589 14.5803 9.31589C14.6365 9.31589 14.6928 9.31012 14.749 9.30002C14.9984 9.25389 15.2176 9.1097 15.3589 8.90064L16.4936 7.20791ZM21.4637 3.21257L22.4124 4.3819L18.6492 7.05508L17.7812 5.75886L21.4637 3.21257ZM23.8312 13.6991L24.9198 15.6268L18.9837 25.3016L23.7086 7.10987L25.6349 11.4253L24.1166 12.4649C23.7173 12.7403 23.5933 13.2766 23.8312 13.6991ZM31.4527 7.01471L24.2507 3.67251L22.372 1.35836C22.0635 0.977711 21.517 0.899851 21.1104 1.17813L16.4936 4.37037L11.8783 1.17813C11.4746 0.899851 10.9267 0.979153 10.6167 1.35692L8.73219 3.67684L1.53884 7.01471C1.1308 7.20503 0.914519 7.65633 1.0241 8.0932L6.86212 31.3761C6.96882 31.7928 7.34225 32.0855 7.77192 32.0855H25.2197C25.6493 32.0855 26.0228 31.7928 26.1295 31.3761L31.9675 8.0932C32.0771 7.65633 31.8608 7.20503 31.4527 7.01471Z"
          fill="black"
        />
      </svg>
    ),
  },
  LivestreamItem: {
    name: 'live_stream',
    label: 'Livestream',
  },
  StoryItem: {
    name: 'category-nlw',
    label: 'Story',
  },
  MoreItem: {
    name: 'more',
    label: 'More',
  },
};

export const PageItemIcon: React.FC<Props> = ({ icon }) => {
  const dataForIcon: IconData = iconData[icon];
  if (!dataForIcon) {
    return null;
  }
  return (
    <div className={styles.container}>
      {dataForIcon.customSvg ? (
        <div className={styles.customSvg}>{dataForIcon.customSvg}</div>
      ) : (
        <Icon name={dataForIcon.name} size="lg" />
      )}
      <Caption className={styles.caption}>{dataForIcon.label}</Caption>
    </div>
  );
};
